import http from '@/shared/http';

class ChatDataService {
  sendMessage(payload) {
    return http.post('/chat/message', payload);
  }
}

export default new ChatDataService();
